import request from '@/base/service'

//  智能原创-根据id获取文章
export function getById(data) {
  return request({
    url: '/original/article/getById',
    method: 'get',
    params: data
  })
}

//  智能原创-提取关键词
export function getKeyword(data) {
  return request({
    url: '/original/article/getKeyword',
    method: 'post',
    data
  })
}

//  获取两篇文章的相似度
export function getSimilarity(data) {
  return request({
    url: '/original/article/getSimilarity',
    method: 'post',
    data
  })
}

//  智能原创-同义词标注
export function getSynText(data) {
  return request({
    url: '/original/article/getSynText',
    method: 'post',
    data
  })
}

//  智能原创-同义词查找
export function getSynWords(data) {
  return request({
    url: '/original/article/getSynWords',
    method: 'get',
    params: data
  })
}

//  智能原创-保存原文
export function articleSave(data) {
  return request({
    url: '/original/article/save',
    method: 'post',
    data
  })
}

//  一键智能原创
export function textRewrite(data) {
  return request({
    url: '/original/article/textRewrite',
    method: 'post',
    data
  })
}

//  智能原创-更新修改后的文章内容
export function articleUpdate(data) {
  return request({
    url: '/original/article/update',
    method: 'post',
    data
  })
}

//  为文章添加点复制、赞、踩的标记
export function addFlag(data) {
  return request({
    url: '/generate/article/addFlag',
    method: 'post',
    data
  })
}

//  自动生成文章
export function autoText(data) {
  return request({
    url: '/generate/article/autoText',
    method: 'post',
    data
  })
}

//  根据关键词和1级行业id获取关键词列表
export function getWordList(data) {
  return request({
    url: '/generate/article/getWordList',
    method: 'get',
    params: data
  })
}

//  根据1级行业id和2级行业id获取关键词列表
export function recommendedKeywords(data) {
  return request({
    url: '/generate/article/recommendedKeywords',
    method: 'get',
    params: data
  })
}

//  根据parentId获取行业分类
export function getByParentId(data) {
  return request({
    url: '/generate/industry/getByParentId',
    method: 'get',
    params: data
  })
}

//  违禁敏感词检测
export function sensitiveCheck(data) {
  return request({
    url: '/original/sensitive/check',
    method: 'post',
    data
  })
}